import cx from "classnames";
import React from "react";
import { withCollapseState } from "../SideNavContexts";
import styles from "./TwoCol.scss";

const getCollapseStyle = (collapseState) =>
  collapseState ? styles[`collapse-state-${collapseState}`] : styles["collapse-state-not-collapsed"];

export const ColWrap = withCollapseState(({ className, collapseState, collapseReverse, isIE, ...props }) => (
  <div
    className={cx(
      styles.ColWrap,
      getCollapseStyle(collapseState),
      className,
      collapseReverse && styles.collapseReverse,
      isIE && styles.isIE
    )}
    {...props}
  />
));

export const MainCol = ({ className, ...props }) => <div className={cx(styles.MainCol, className)} {...props} />;

export const SecondaryCol = ({ className, ...props }) => (
  <div className={cx(styles.SecondaryCol, className)} {...props} />
);
